export enum ConnectHiringRequestAction {
  scorecard = 'scorecard',
  reference = 'reference',
  application = 'application',
}
